import React, { Component } from 'react';
import _ from 'lodash';
import DisableNextModal from '../../../shared/Common/disableNextModal';
import ResultsTabs from './ResultsTabs/ResultsTabs';
import { Link } from 'react-router-dom';
import { Chart } from "react-google-charts";
import ReactToPrint from "react-to-print";
import ComponentToPrint from './ComponentToPrint/ComponentToPrint';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
class Results extends Component {
    constructor(props) {
        super(props);
        this.defaultParams;
        this.state = {
            tabs: [],
            print: false,
        };
    }
    componentWillReceiveProps(nextProps) {
        if (this.props.segmentation.editData !== nextProps.segmentation.editData) {
            let body = {
                projectId: this.props.projectId,
                type: "segmentation"
            }
            let data = {
                projectId: this.props.projectId,
                type: "benefitsLadder"
            }
            this.props.getSegmentation(body)
            this.props.getBenefitsLadder(data)
        }
        if (this.props.segmentation.segmentationData !== nextProps.segmentation.segmentationData) {
            this.setState({
                segmentation: nextProps.segmentation.segmentationData.Items[0],
                benefits: nextProps.benefits.benefitsLadderData.Items[0].data,
            })
        }
    }
    elementInfiniteLoad() {
        return (
            <div className='col-sm-12'>
                <div className='spinner3'>
                    <div className='rect1' />
                    <div className='rect2' />
                    <div className='rect3' />
                    <div className='rect4' />
                    <div className='rect5' />
                </div>
            </div>
        );
    }
    downloadPDF = () => {
        let print = document.getElementById('chartPrint');
        print.style.display = 'block'
        html2canvas(print)
            .then((canvas) => {
                let wid
                let hgt
                const imgData = canvas.toDataURL('image/png', wid = canvas.width, hgt = canvas.height);
                let hratio = hgt/wid
                let pdf = new jsPDF('p','pt','a4');
                let width = pdf.internal.pageSize.width;
                let height = width * hratio
                pdf.addImage(imgData,'JPEG',0,0, width, height);
                pdf.save("segments.pdf");
                print.style.display = 'none'
            });
    };

    render() {
        if (this.props.segmentation.editFetched && this.props.segmentation.segmentationFetched && this.props.benefits.benefitsLadderFetched && this.props.segmentation.segmentationData.Items.length !== 0 && this.state.tabs.length === 0 && this.state.segmentation) {
            let tabs = [];
            let benefits = [...this.state.benefits];
            // let percent = [...this.state.segmentation.percent];
            let groups = _.uniqBy(this.state.segmentation.segments, "groupId");
            let segments = [...this.state.segmentation.segments];
            benefits.map(benefit => {
                groups.map(group => {
                    if (benefit.groupId === group.groupId) {
                        tabs.push({
                            groupName: benefit.groupName,
                            groupId: group.groupId,
                            // percent: _.filter(percent, (o) => { return o.groupId === group.groupId }),
                            segments: _.filter(segments, (o) => { return o.groupId === group.groupId }),
                        })
                    }
                })
            })
            this.setState({ tabs })
        }
        return (
            <div className='customer-groups-content'>
                <div className='step-bar'>
                    <div className='step step-three arrow-step'>
                        <p>Step 1</p>
                    </div>
                    <div className='step step-three arrow-step'>
                        <p>Step 2</p>
                    </div>
                    <div className='step step-three arrow-step active-step'>
                        <p>Result</p>
                    </div>
                </div>
                {(!this.props.segmentation.segmentationFetching && !this.props.benefits.benefitsLadderFetching && !this.props.segmentation.editFetching) && <div className='container-fluid'>
                    <div className="row">
                      <div className="col-sm-12">
                        <h5>SEGMENTATION</h5>
                      </div>
                    </div>
                    <div className='row'>
                        <div className='col-xl-7 col-lg-9 col-md-10'>
                            <div className='card'>
                                <div className='card-header'>
                                    <h5>Results</h5>
                                </div>
                                <div className='card-body'>
                                    <ResultsTabs
                                        tabs={this.state.tabs}
                                        tabStep={this.props.tabStep}
                                        onTabChange={this.props.onTabChange}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className='col-sm-12'>
                            <div className='card'>
                                <div className='card-body'>
                                    <Link className='btn btn-success' to={'/competitive-analysis/'+this.props.projectId}> Next </Link>
                                    <Link to='/toolkit' className='btn btn-success'> Done </Link>
                                    <div className='btn empty-btn default' onClick={this.downloadPDF}>Save PDF</div>

                                    <ReactToPrint
                                        trigger={() => <a className='btn empty-btn default' href="#">Print</a>}
                                        content={() => this.componentRef}
                                    />
                                    <div style={{ display: "none" }} id="chartPrint">
                                        <ComponentToPrint
                                            ref={el => (this.componentRef = el)}
                                            tabs={this.state.tabs}
                                        />
                                    </div>
                                    <div className='btn empty-btn default' onClick={this.props.groupStateBack}> Back </div >
                                </div>
                            </div>
                        </div>

                    </div>
                </div>}
                {(this.props.segmentation.segmentationFetching || this.props.benefits.benefitsLadderFetching || this.props.segmentation.editFetching) &&
                    <div className='card'>
                        <div className="card-body">
                            {this.elementInfiniteLoad()}
                        </div>
                    </div>
                }
                {this.props.disableNextState &&
                    <DisableNextModal
                        disableNextState={this.props.disableNextState}
                        disableNextModal={this.props.disableNextModal}
                        disableModalText="Each group's segment weights must equal 100"
                        disableModalTitle='Notice'
                    />

                }
            </div>
        )
    }
}

export default (Results);



// WEBPACK FOOTER //
// ./src/components/Segmentation/Results/Results.jsx